/* eslint-disable max-len */
import React from 'react';
import {AppState} from '../../App';

import './Team.scss';

interface TeamProps {
  state: AppState;
}

const PlaceholderAvatar = () => (
  <svg
    width="150"
    height="150"
    viewBox="0 0 150 150"
    fill="none"
    style={{
      transform: 'scale(1.1)',
    }}
    xmlns="http://www.w3.org/2000/svg"
    className="placeholder-avatar"
  >
    <circle cx="75" cy="75" r="75" fill="#E5E7EB" />
    <circle cx="75" cy="60" r="25" fill="#9CA3AF" />
    <path
      d="M75 95C45 95 25 115 25 145H125C125 115 105 95 75 95Z"
      fill="#9CA3AF"
    />
  </svg>
);

export default function Team({state}: TeamProps) {
  return (
    <div className="Team">
      <h1>Our Team</h1>
      <div className="team-description">
        <p>
          The EUSEAR core team consists of Alfred Gerstl (principal investigator), Vladimira Lickova, Michał Lubina, Nick Nieschalke, Martin Sebena, Matej Simalcik, and Oliver Thurin. Their interdisciplinary expertise complements each other perfectly and enables different approaches to analyzing the European-Southeast Asian relations.
        </p>
        <p>
          Moreover, Master students from the University of Vienna (Department of Asian Studies/East Asian Economy and Society) contribute to EUSEAR project activities such as the Europe-Southeast Tracker, namely: Yu-Chen Chou, Markus Eberle, Lena Heyer, Josephine Kolehmainen, Daria Kozlova, Nina Kupreeva, Laurine Levaux, Zoe Pangrazzi, Alyssa Mancuso de Souza, Elisabeth Saulnier, Ugnius Sejonas, Ole Stark, and Ema Vida.
        </p>
      </div>
      <div className="team">
        {state.team.map((member) => {
          return (
            <div key={member.NAME}>
              <a href={member.CEIAS_LINK} target="_blank" rel="noopener noreferrer" className="thumbnail">
                {member.PICTURE ? (
                  <img src={member.PICTURE} alt={member.NAME} />
                ) : (
                  <PlaceholderAvatar />
                )}
              </a>
              <div>
                <a href={member.CEIAS_LINK} target="_blank" rel="noopener noreferrer" className="name">{member.NAME}</a>
                <p>{member.TITLE}</p>
                <p className="email">{member.EMAIL}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

